<template>
  <!-- eslint-disable vue/no-template-key -->
  <!-- eslint-disable vue/valid-v-for -->
  <div v-if="totalNotifications > 0">
    <template v-for="orderNotif in notifications.orderInfo" :key="orderNotif.orderId">
      <OrderNotification :order-notif="orderNotif" />
    </template>
    <AddCardToWallet v-if="notifications.addCardToWallet" />
    <template v-for="(cardNumber, index) in cardNumbers" :key="index">
      <CreditCards :card-number="cardNumber" />
    </template>
    <template v-for="(rewardCard, index) in notifications.loyaltyRewardCards" :key="index">
      <RewardsCards :reward-card="rewardCard" />
    </template>
    <CreditCards v-if="notifications.makePropCardDefault" />
    <EnrollRewards v-if="notifications.enrollLoyalty" />
    <StarRewardsDowngrade v-if="notifications.starRewardsDowngradeInfo" :rewards-downgrade-info="notifications.starRewardsDowngradeInfo" />
  </div>
  <div v-else>
    <div class="msg-cont grid-x align-center padding-top-xxxl">
      <div :class="currentBrand === 'mcom' ? 'email-filled' : 'email'" class="cell inbox-icon"></div>
      <h3 class="cell large padding-top-xs grid-x align-center">
        {{ INBOX.noNewMessageText }}
      </h3>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { INBOX } from 'config';
import { useNotificationStore } from '@/stores/useNotificationStore';
import AddCardToWallet from './AddCardToWallet';
import EnrollRewards from './EnrollRewards';
import CreditCards from './CreditCards';
import OrderNotification from './OrderNotification';
import RewardsCards from './RewardsCards';
import StarRewardsDowngrade from './StarRewardsDowngrade';

const notificationStore = useNotificationStore();

const totalNotifications = computed(() => notificationStore.getTotalNotifications);

const notifications = computed(() => notificationStore.notifications);
const cardNumbers = computed(() => notifications.value?.linkPropCardsToFusion?.cardNumbers);
</script>

<style lang="scss" scoped>
::v-deep(.acc-notif-item) {
  border-bottom: $gray-3-border;
}
</style>
<style lang="scss" brand="mcom" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_email-filled.scss';
</style>
<style lang="scss" brand="bcom" scoped>
@import '~@core/csg/src/scss/encodedIcons/bcom/_email.scss';
</style>
